import { modelSupport } from "../../models/global";
import { modelHubAgenda, modelHubAssinatura } from "../../models/hub";
import { HubController } from "./hub-controller";

let hubController = null;

export function controllerHub() {
  if (!hubController) {
    hubController = new HubController({
      models: {
        agenda: modelHubAgenda(),
        support: modelSupport(),
        assinatura: modelHubAssinatura(),
      }
    })
  }
  return hubController;
}
